import React from 'react';
import { Link } from 'react-router-dom';

const AIProductsQuickAccess = ({ user }) => {
  if (!user?.email) return null;

  return (
    <Link
      to={`/productoai/${encodeURIComponent(user.email)}`}
      className="ai-products-quick-access"
      aria-label="Abrir Mis Productos IA"
      title="Mis Productos IA"
    >
      <i className="fa-solid fa-robot" aria-hidden="true"></i>
      <span>Mis Productos IA</span>
    </Link>
  );
};

export default AIProductsQuickAccess;
